import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const TablePageSize = ({ pages, onChange }) => {
  return (
    <div className="pages-count__content">
      <span className="pages-count__title">Показать на странице</span>
      <Select
        defaultValue={pages}
        style={{ width: 80 }}
        onChange={e => onChange(e)}
        getPopupContainer={trigger => trigger.parentNode}
      >
        <Option value="3">3</Option>
        <Option value="5">5</Option>
        <Option value="10">10</Option>
      </Select>
    </div>
  );
};

export default TablePageSize;
